import React, { forwardRef, LegacyRef } from 'react'

import { Box } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import { useDesktopMediaQuery } from '@/utils'

import useStickyHeader from '../../hooks/use-sticky-header'
import DateSwitcher from '../date-switcher'
import ExposedFilter from '../filters/mobile/exposed-filter'
import MapWrapper from '../map-wrapper'
import ProductionDetailBar from '../production-detail-bar'
import ProductionListingsBanner from '../production-listings-banner'

import styles from './styles.module.scss'

const ListingHeader: React.ForwardRefExoticComponent<{
    clickFilters: () => void
    isMapOpen: boolean
    ref?: React.Ref<unknown>
    referer?: string
    toggleMap?: () => void
}> = forwardRef(({ clickFilters, isMapOpen, referer, toggleMap }, ref) => {
    const isDesktop = useDesktopMediaQuery()
    const [listingsHeaderPositionRef, isListingsHeaderSticky] = useStickyHeader(0)

    const mergedListingsHeaderClassName = classNames(styles.listingsHeader, {
        [styles.stickyListingsHeader]: isListingsHeaderSticky,
    })

    return (
        <>
            <div ref={listingsHeaderPositionRef} data-testid="listings-header-position-ref" />
            <div className={mergedListingsHeaderClassName} data-testid="listings-header" id="listings-header">
                <div className={styles.smallVerticalPadding}>
                    <div className={styles.headerPadding}>
                        <ProductionDetailBar referer={referer} />
                    </div>
                    <Box mobileDisplay="block" tabletDisplay="block" desktopDisplay="none">
                        <ExposedFilter clickFilters={clickFilters} ref={ref} />
                    </Box>
                </div>
                {!isDesktop && isMapOpen && (
                    // Need to use a isDesktop && instead of desktopDisplay="none",
                    // or else the svg map will still be rendered.
                    <Box mobileDisplay="block" tabletDisplay="block" desktopDisplay="none" data-testid="map-wrapper">
                        <div
                            className={styles.mapContainer}
                            ref={ref as LegacyRef<HTMLDivElement>}
                            data-testid="map-container"
                        >
                            <MapWrapper withPanAndZoom isDesktop={false} toggleMap={toggleMap} padding="tight" />
                        </div>
                    </Box>
                )}
                <Box mobileDisplay="none" tabletDisplay="none" desktopDisplay="block">
                    <DateSwitcher />
                </Box>
                <ProductionListingsBanner className={styles.bannerPadding} />
            </div>
        </>
    )
})

export default ListingHeader
